import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Directive({
  selector: '[appIsDateBefore]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: IsDateBeforeDirective,
      multi: true
    }
  ]
})

export class IsDateBeforeDirective {
  @Input('appIsDateBefore') date: NgbDateStruct;

  constructor(
    private calendar: NgbCalendar,
  ) { }

  private isDateBeforeValidator(date: NgbDateStruct): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const controlDate = NgbDate.from(control.value);
      const comparisonDate = NgbDate.from(date);
      if (this.calendar.isValid(controlDate) &&
          this.calendar.isValid(comparisonDate) &&
          comparisonDate.before(controlDate)) {
        return {
          isDateBeforeAfter: {
            value: 'before'
          }
        };
      }
      return null;
    };
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.date ? this.isDateBeforeValidator(this.date)(control) : null;
  }
}

@Directive({
  selector: '[appIsDateAfter]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: IsDateAfterDirective,
      multi: true
    }
  ]
})

export class IsDateAfterDirective {
  @Input('appIsDateAfter') date: NgbDateStruct;

  constructor(
    private calendar: NgbCalendar,
  ) { }

  private isDateAfterValidator(date: NgbDateStruct): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const controlDate = NgbDate.from(control.value);
      const comparisonDate = NgbDate.from(date);
      if (this.calendar.isValid(controlDate) &&
        this.calendar.isValid(comparisonDate) &&
        comparisonDate.after(controlDate)) {
        return {
          isDateBeforeAfter: {
            value: 'after'
          }
        };
      }
      return null;
    };
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.date ? this.isDateAfterValidator(this.date)(control) : null;
  }
}
